import * as React from 'react'

function SvgAuthenticationDesktopHeroBG(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 1441 410" fill="none" {...props}>
      <path
        d="M.403 409.267V173.455s266.956 71.886 714.764 46.043C1162.97 193.656 1440.4.773 1440.4.773v408.494H.403z"
        fill="url(#prefix__paint0_radial_authentication_desktop_hero_bg)"
      />
      <defs>
        <radialGradient
          id="prefix__paint0_radial_authentication_desktop_hero_bg"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(356.0007 1476.00457 -3122.15995 753.04042 975 -844)"
        >
          <stop stopColor="#03CDFE" />
          <stop offset={0.523} stopColor="#317CE9" />
          <stop offset={0.958} stopColor="#E9315D" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SvgAuthenticationDesktopHeroBG
